import React from 'react'

export default function SplitViewSidebarContent({ className='', children }) {
    return (
        <div className={'ui-sv-content-sidebar'+' '+className}>
            {children}
        </div>
    )
}